import React, { useState, useEffect, useRef, forwardRef } from "react";
import ttAPI from '../../api/ttAPI';
import { Grid, IconButton, MenuItem, Menu, ListItemIcon, ListItemText, TableRow,
         TableCell, Typography} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import debounce from 'lodash.debounce';
// components
import PageTitle from "../../components/PageTitle";

// Icons
import {
    MoreVert as MoreVertIcon,
    GetApp as GetAppIcon,
    Send as SendIcon,
    CardMembership as CardMembershipIcon,
    ListAlt as ListAltIcon,
    FileCopy as FileCopyIcon,
    Receipt as ReceiptIcon,
    Pageview as PageviewIcon,
    Replay as ReplayIcon,
    Chat as ChatIcon,
    History as  HistoryIcon,
    OpenInNew as OpenInNewIcon
} from '@material-ui/icons'

import { sendNotification, useUserState } from "../../context/UserContext";
import useStyles from './styles';
import config from '../../config';

//import SelectCustomerOrJob from '../../components/Customer/SelectCustomerOrJob';
import JobReportEmail from '../../components/JobReportEmail/JobReportEmail';
import JobReopen from '../../components/JobReopen/JobReopen';
import CustomerDownloadCSVConfirmation from '../../components/CustomerDownloadCSVConfirmation/CustomerDownloadCSVConfirmation';

const ClosedJobs = forwardRef((props, ref) => {
//export default function Jobs() {
  // global
  const classes = useStyles();
  const history = useHistory();
  var { user_name, testing_scopes } = useUserState();

  // local
  var [data, setData] = useState([]);
  var [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const jobReportEmailsRef = useRef(null);
  const [email, setEmail] = useState({
    job_id: -1,
    message: '',
    emails: [],
    customer_name: '',
    attach_certificate: true,
    attach_invoice_report: true,
    date: '',
  });
  const [emailIsOpen, setEmailIsOpen] = useState(false);
  const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
  const delayedOnSearchKey = useRef(debounce(q => onSearchKey(q), 500)).current;
  const jobReopenRef = useRef(null);
  const [jobReopenIsOpen, setJobReopenIsOpen] = useState(false);
  const customerDownloadCSVConfirmationRef = useRef(null);
  const [isAll, setIsAll] = useState(props.id === undefined || props.id === null || props.id <= 0);

  //const [selectedCustomerOrJob, setSelectedCustomerOrJob] = useState(undefined);

  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  useEffect(() => {
     let mounted = true;
     const fetchData = async() => {
       var response = null;

       if (props.id === undefined || props.id === null || props.id <= 0) {
         if (localStorage.getItem('closed_jobs_search_text') !== undefined && localStorage.getItem('closed_jobs_search_text') !== null) {
            if (localStorage.getItem('closed_jobs_search_text') !== 'null' && localStorage.getItem('closed_jobs_search_text') !== 'undefined') {
                response = await ttAPI.getClosedJobs(localStorage.getItem('closed_jobs_search_text'));
            }
         }
       }
       else {
          if (isUseCachedTableSettings()) {
              if (localStorage.getItem('customer_closed_jobs_search_text') !== undefined && localStorage.getItem('customer_closed_jobs_search_text') !== null) {
                 if (localStorage.getItem('customer_closed_jobs_search_text') !== 'null' && localStorage.getItem('customer_closed_jobs_search_text') !== 'undefined') {
                     response = await ttAPI.getCustomerClosedJobsByKey(props.id, localStorage.getItem('customer_closed_jobs_search_text'));
                 }
                 else {
                     response = await ttAPI.getCustomerClosedJobs(props.id);
                 }
              }
              else {
                response = await ttAPI.getCustomerClosedJobs(props.id);
              }
          }
          else {
              response = await ttAPI.getCustomerClosedJobs(props.id);
          }
       }

       if(mounted){
          setData(response);
       }
     };
     //if (props.id !== undefined && props.id !== null && props.id > 0) {
       fetchData();
     //}

     return () => mounted = false;

  }, [props.id]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRowIndex(-1);
    setIsMenuOpen(false);
  };

  const openEmail = () => {
    setEmailIsOpen(true);
  };

  function triggerOpenEmail(selectedEmail) {
    jobReportEmailsRef.current.openEmail(selectedEmail);
  }


  const generateCertificate = event => {
      window.open(`${config.clientApi}/reports/certificate.pdf?jobid=${data[selectedRowIndex].id}&date=${data[selectedRowIndex].completed}`,'_blank');
  }

  const downloadCustomerAssetsCSV = () => {
    customerDownloadCSVConfirmationRef.current.openConfirmationPopup(data[selectedRowIndex].customer_id, data[selectedRowIndex].customer);
    handleClose();
  }

  const downloadInvoicePdf = () => {
    window.open(
    `${config.clientApi}/reports/asset_testing.pdf?invf=-1&jobid=${data[selectedRowIndex].id}`,
    '_blank'
    );
    handleClose();
  }

  const openInvoiceSummary = () => {
    window.open(
    `${config.adminApi}/#/app/invoice/summary/${data[selectedRowIndex].id}`,
    '_blank'
    );
    handleClose();
  }

  const openViewAssets = () => {
    window.open(
    `${config.clientApi}/view_assets.jsp?id=${data[selectedRowIndex].id}`,
    '_blank'
    );
    handleClose();
  }

  const copyJob = async() => {
    const response = await ttAPI.copyJob(data[selectedRowIndex].id);
    if (response > 0) {
        sendNotification('success', `Success - Job ${data[selectedRowIndex].id} Copied into New Job ${response}.`, classes);
        if (props.id === undefined || props.id === null || props.id <= 0) {
            history.push({pathname:`/app/job/edit/${response}`,
                    state:{jobId: response}
                  });
        }
        else {
            window.open(
                `${config.adminApi}/#/app/job/edit/${response}`,
                '_blank'
              );
        }
    }
    else {
        sendNotification('error', `Failed to copy Job ${data[selectedRowIndex].id}.`, classes);
    }
    handleClose();
  }

  const downloadHistory = () => {
    window.open(`${config.clientApi}/reports/audit/job?id=${data[selectedRowIndex].id}`,'_blank');
  }

  const downloadJSA = () => {
    window.open(`${config.clientApi}/report/form?is_jsa=true&is_pdf=true&jobid=${data[selectedRowIndex].id}`,'_blank');
  }

  function downloadFailedReport() {
    window.open(`${config.clientApi}/report/failed_job_report?jobid=${data[selectedRowIndex].id}`,'_blank');
  }

  function downloadJobIssuesReport() {
    window.open(`${config.clientApi}/report/job_issues_report?jobid=${data[selectedRowIndex].id}`,'_blank');
  }

  const StyledMenuItem = withStyles((theme) => ({
      root: {
        '&:focus': {
          backgroundColor: theme.palette.primary.main,
          '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
            color: theme.palette.common.white,
          },
        },
      },
    }))(MenuItem);

  const [columns, setColumns] = useState([
    { label: 'ID', name: 'id', options: {filter: false, display: true}},
    { label: 'Customer', name: 'customer', options: {display:true} },
    { label: 'Site', name: 'site', options: {filter: false, display: true} },
    { label: 'Start',
      name: 'start_date',
      options: {
          filter: false,
          display: true,
          sortCompare: (order) => {
            return (obj1, obj2) => {
              let val1 = new Date(obj1.data);
              let val2 = new Date(obj2.data);
              var num = 0;
              if (val1 < val2) {
                  num = -1;
              }
              else if (val1 > val2) {
                  num = 1;
              }
              else {
                  num = 0
              }
              return num * (order === 'asc' ? 1 : -1);
            };
          },
              } },
    { label: 'Services',
      name: 'services',
      options: {
        filter: true,
        display: true,
        filterOptions: {names:testing_scopes === undefined || testing_scopes === null ? []  : testing_scopes.map(s => s.name)},
        customBodyRender: (value, tableMeta) => {
          return (<div>{value === undefined || value === null ? '' : value.join(',')}</div>);
        },
      }},
    { label: 'Work Completed', name: 'work_completed', options: {display:true} },
    { label: 'Action',
        name: 'action',
        options: {
          filter: false,
          sort: false,
          empty: true,
          display: true
        }
      },
  ]);

  const [columnsForCustomer, setColumnsForCustomer] = useState([
    { label: 'ID', name: 'id', options: {filter: false, display: true}},
    { label: 'Site', name: 'site', options: {filter: false, display: true} },
    { label: 'Start', name: 'start_date', options: {filter: false, display: true} },
    { label: 'Services',
      name: 'services',
      options: {
        filter: true,
        display: true,
        filterOptions: {names:testing_scopes === undefined || testing_scopes === null ? []  : testing_scopes.map(s => s.name)},
        customBodyRender: (value, tableMeta) => {
          return (<div>{value === undefined || value === null ? '' : value.join(',')}</div>);
        },
      }},
    { label: 'Work Completed', name: 'work_completed',options: {display:true} },
    { label: 'Action',
        name: 'action',
        options: {
          filter: false,
          sort: false,
          empty: true,
          display: true
        }
      },
  ]);

  const getMuiTheme = () => createMuiTheme({
    palette: {
     primary: {
       main: '#FFCA06',
     },
   },
     overrides: {
       MUIDataTableFilter: {
         root: {
           width: '500px',
         }
       },
       MuiTableCell: {
           root: {
               padding: '0px 16px',
           },
       },
     }
   });


    useEffect(() => {
        if (props.location !== undefined && props.location.state !== undefined && props.location.state.jobId !== undefined) {
            sendNotification('success', `Success - Job ${props.location.state.jobId} Updated'}.`, classes);
        }
    },[props.location, sendNotification]);

    function onResultsReturned(closedJobList) {
      //setSelectedCustomerOrJob(customerOrJob);
      setData(closedJobList);
    }

  useEffect(() => {
    //console.log('selectedRowIndex', selectedRowIndex, 'emailIsOpen', emailIsOpen);
      if (selectedRowIndex >= 0 && emailIsOpen) {
        //console.log('set email details, for job id ' + data[selectedRowIndex].id);
        var emails = [];
        if (data[selectedRowIndex].customer_email !== undefined &&
            data[selectedRowIndex].customer_email !== null &&
            pattern.test(data[selectedRowIndex].customer_email)) {
                emails.push(data[selectedRowIndex].customer_email);
        }

        if (data[selectedRowIndex].site_email !== undefined &&
            data[selectedRowIndex].site_email !== null &&
            pattern.test(data[selectedRowIndex].site_email)) {
                emails.push(data[selectedRowIndex].site_email);
        }

        triggerOpenEmail({
          job_id: selectedRowIndex > -1 ? data[selectedRowIndex].id : -1,
          message: '',
          emails: emails,
          customer_name: selectedRowIndex > -1 ? (props.id === undefined || props.id === null || props.id <= 0 ? data[selectedRowIndex].customer : props.name) :'',
          attach_certificate: true,
          attach_invoice_report: true,
          date: selectedRowIndex > -1 ? data[selectedRowIndex].completed : '',
        });
        setEmailIsOpen(false)
      }
  },[selectedRowIndex, emailIsOpen]);

  useEffect(() => {
      if (selectedRowIndex >= 0 && jobReopenIsOpen) {
        triggerOpenJobReopen(selectedRowIndex > -1 ? data[selectedRowIndex].id : -1);
        setJobReopenIsOpen(false);
      }
  },[selectedRowIndex, jobReopenIsOpen]);

  function triggerOpenJobReopen(jobIdToComplete) {
    console.log(jobIdToComplete);
    jobReopenRef.current.openReopenPopup(jobIdToComplete);
  }

  async function onSearchKey(key) {
    if (key !== undefined && key !== null && key !== '' && key.length >= 3) {
      var response = null;
      if (props.id !== undefined && props.id !== null && props.id > 0) {
          response = await ttAPI.getCustomerClosedJobsByKey(props.id, key);
      }
      else {
          response = await ttAPI.getClosedJobs(key);

      }

      if (response !== null) {
          setData(response);
      }
      else {
          setData([]);
      }
    }
    else {
      if (props.id !== undefined && props.id !== null && props.id > 0) {
          response = await ttAPI.getCustomerClosedJobs(props.id);
          setData(response);
      }
      else {
          setData([]);

      }

    }
  };

  async function refreshData() {
    if (props.id !== undefined && props.id !== null && props.id > 0) {
        const response = await ttAPI.getCustomerClosedJobs(props.id);
        setData(response);
    }
    else {
        setData([]);
    }
  }

  function isUseCachedTableSettings() {
    var useCachedTableSettings = false;
    if (localStorage.getItem('customer_opened') !== undefined && localStorage.getItem('customer_opened') !== null) {
       if (localStorage.getItem('customer_opened') !== 'null' && localStorage.getItem('customer_opened') !== 'undefined') {
           var prevCustomerId = parseInt(localStorage.getItem('customer_opened'));
           var currentCustomerId = props.id;
           if (prevCustomerId == currentCustomerId) {
               console.log("same customer");
               useCachedTableSettings = true;
           }
       }
    }
    else {
        localStorage.setItem('customer_opened', props.id);
    }
    return useCachedTableSettings;
  }

  const openJobReopen = () => {
      setJobReopenIsOpen(true);
  };

  const openTeamChat = async () => {
    const emails = await ttAPI.getJobWorkerEmails(data[selectedRowIndex].id);
    console.log(emails);
    if (emails !== null && emails !== undefined && emails !== '') {
      window.open(
      `${config.teamChatUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>',`Job%20${data[selectedRowIndex].id}%20Chat`)}`,
      '_blank'
      );
    }

    handleClose();
  }

  const openInNewTab = () => {
    window.open(
            `${config.adminApi}/#/app/job/edit/${data[selectedRowIndex].id}`,
            '_blank'
          );
    handleClose();
  }

  const onCellClick = (dataIndex, colIndex) => {
    setSelectedRowIndex(dataIndex);
    if (!isMenuOpen) {
        if (colIndex !== (isAll ? columns.length : columnsForCustomer.length) - 1 ) {
          // hard code accounts to open open jobs in a new tab
          let openJobInNewTab = localStorage.getItem('open_job_in_new_tab') === 'true';
          if (user_name === 'Simon Li' || !isAll || openJobInNewTab) {
              window.open(
                      `${config.adminApi}/#/app/job/edit/${data[dataIndex].id}`,
                      '_blank'
                    );
          }
          else {
              history.push({pathname:`/app/job/edit/${data[dataIndex].id}`,
                                             state:{jobId: data[dataIndex].id}
                                           });
          }

        }
    }
  }

  return (
    <>
      { (props.id === undefined || props.id === null || props.id <= 0)  && <PageTitle title="Closed Job List" />}
      <Grid container spacing={4}>
      {/*(props.id === undefined || props.id === null || props.id <= 0) && <Grid item xs={12}>
          <Widget inheritHeight noHeader>
              <Box
                  justifyContent={'space-between'}
                  display={'flex'}
                  alignItems={'flex-start'}
              >

                      <SelectCustomerOrJob onResults={onResultsReturned}/>

              </Box>
          </Widget>
      </Grid>*/}
      <Grid item xs={12}>
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            data={data !== undefined && data !== null && data.length > 0 ? data.map(item => {
                return props.id === undefined || props.id === null || props.id <= 0 ? [
                    item.id,
                    item.customer,
                    item.site,
                    item.start_date,
                    item.services ? item.services.map(s => s.name) : null,
                    item.work_completed ? 'YES' : 'NO',
                    item.customer_id,
                    item.customer_email,
                    item.site_email,
                ] : [
                    item.id,
                    item.site,
                    item.start_date,
                    item.services ? item.services.map(s => s.name) : null,
                    item.work_completed ? 'YES' : 'NO',
                    item.customer_id,
                    item.customer_email,
                    item.site_email,
                ]
            }) : []}
            columns={props.id === undefined || props.id === null || props.id <= 0 ? columns : columnsForCustomer}
            options={{
              fixedHeader: true,
              tableBodyHeight: '70vh',
              filterType: "multiselect",
              searchOpen: true,//props.id !== undefined && props.id !== null && props.id > 0,
              print: false,
              viewColumns: true,
              selectableRows: 'none',
              rowsPerPageOptions: [10,15,20,50,100],
              downloadOptions: {filterOptions:{useDisplayedColumnsOnly: true, useDisplayedRowsOnly: false}},
              /*onRowClick: row => {

                      history.push({pathname:`/app/job/edit/${row[0]}`,
                                    state:{jobId: row[0]}
                                  });

              },*/
              onCellClick: (col, cellMeta) => {
                //console.log('selectedRowIndex set to ', cellMeta.dataIndex, isMenuOpen)
                if (!isMenuOpen) {
                  setSelectedRowIndex(cellMeta.dataIndex);
                  if (cellMeta.colIndex !== (props.id === undefined || props.id === null || props.id <= 0 ? columns.length - 1 : columnsForCustomer.length - 1)) {
                    if (props.id === undefined || props.id === null || props.id <= 0) {
                        // hard code accounts to open open jobs in a new tab
                        let openJobInNewTab = localStorage.getItem('open_job_in_new_tab') === 'true';
                        if (user_name === 'Simon Li' || openJobInNewTab) {
                            window.open(
                                    `${config.adminApi}/#/app/job/edit/${data[cellMeta.dataIndex].id}`,
                                    '_blank'
                                  );
                        }
                        else {
                            history.push({pathname:`/app/job/edit/${data[cellMeta.dataIndex].id}`,
                                      state:{jobId: data[cellMeta.dataIndex].id}
                                    });
                        }
                    }
                    else {
                        window.open(
                                `${config.adminApi}/#/app/job/edit/${data[cellMeta.dataIndex].id}`,
                                '_blank'
                              );
                    }
                  }
                }


              },
              onChangePage:(currentPage) => {
                if (props.id === undefined || props.id === null || props.id <= 0) {
                    localStorage.setItem('closed_jobs_page', currentPage);
                }
                else {
                    localStorage.setItem('customer_closed_jobs_page', currentPage);
                }

              },
              onChangeRowsPerPage: (numberOfRows) => {
                localStorage.setItem('closed_jobs_rows_per_page', numberOfRows);
              },
              onSearchChange: (searchText) => {
                if (props.id === undefined || props.id === null || props.id <= 0) {
                    localStorage.setItem('closed_jobs_search_text', searchText);
                }
                else {
                    localStorage.setItem('customer_closed_jobs_search_text', searchText);
                }

                delayedOnSearchKey(searchText);
              },
              onSearchClose: () => {
                 refreshData();
              },
              customSearch: (searchQuery, currentRow, columns) => {
                 return data.find(j=> j.id === currentRow[0]) !== undefined;
              },
              /*customSearch: (searchQuery, currentRow, columns) => {
                 let isFound = false;
                 currentRow.forEach(col => {
                   if (col !== null && col !== undefined && col !== ''  &&
                       col.toString().replace(/(\r\n|\n|\r)/gm,' ').indexOf(searchQuery) >= 0) {
                     isFound = true;
                   }
                 });
                 return isFound;
               },*/
               onTableInit: (action, tableState) => {
                   if (props.id === undefined || props.id === null || props.id <= 0) {
                     if (localStorage.getItem('closed_jobs_search_text') !== undefined && localStorage.getItem('closed_jobs_search_text') !== null) {
                        if (localStorage.getItem('closed_jobs_search_text') !== 'null' && localStorage.getItem('closed_jobs_search_text') !== 'undefined') {
                            tableState.searchText = localStorage.getItem('closed_jobs_search_text');
                        }
                     }

                     if (localStorage.getItem('closed_jobs_page') !== undefined && localStorage.getItem('closed_jobs_page') !== null && localStorage.getItem('closed_jobs_page') >= 0) {
                       if (localStorage.getItem('closed_jobs_page') !== 'null' && localStorage.getItem('closed_jobs_page') !== 'undefined') {
                           tableState.page = parseInt(localStorage.getItem('closed_jobs_page'));
                       }
                     }
                   }
                   else {
                       if (isUseCachedTableSettings()) {
                           if (localStorage.getItem('customer_closed_jobs_search_text') !== undefined && localStorage.getItem('customer_closed_jobs_search_text') !== null) {
                              if (localStorage.getItem('customer_closed_jobs_search_text') !== 'null' && localStorage.getItem('customer_closed_jobs_search_text') !== 'undefined') {
                                  tableState.searchText = localStorage.getItem('customer_closed_jobs_search_text');
                              }
                           }

                           if (localStorage.getItem('customer_closed_jobs_page') !== undefined && localStorage.getItem('customer_closed_jobs_page') !== null) {
                             if (localStorage.getItem('customer_closed_jobs_page') !== 'null' && localStorage.getItem('customer_closed_jobs_page') !== 'undefined') {
                                 tableState.page = parseInt(localStorage.getItem('customer_closed_jobs_page'));
                             }
                           }
                       }
                   }


                   if (localStorage.getItem('closed_jobs_rows_per_page') !== undefined && localStorage.getItem('closed_jobs_rows_per_page') !== null &&
                       localStorage.getItem('closed_jobs_page') !== 'null' && localStorage.getItem('closed_jobs_page') !== 'undefined') {
                         tableState.rowsPerPage = parseInt(localStorage.getItem('closed_jobs_rows_per_page'));
                   }
                   else {
                     tableState.rowsPerPage = 100;
                   }

                   // find if there are hidden columns set
                   if (isAll) {
                       if (localStorage.getItem('closed_jobs_columns_hide') !== undefined && localStorage.getItem('closed_jobs_columns_hide') !== null &&
                           JSON.parse(localStorage.getItem('closed_jobs_columns_hide')) !== undefined && JSON.parse(localStorage.getItem('closed_jobs_columns_hide')) !== null) {
                             // hide them on the current table
                             var columnsToHide = JSON.parse(localStorage.getItem('closed_jobs_columns_hide'));
                             for (let i = 0; i < columnsToHide.length; i++) {
                               if (tableState.columns.length > i && tableState.columns[i] !== undefined && tableState.columns[i] !== null) {
                                   tableState.columns[i].display = false;
                               }
                             }

                             if (columnsToHide !== undefined && columnsToHide !== null && columnsToHide.length > 0) {
                                 var newCols = columns.map((col, index) => {
                                   let newCol = Object.assign({}, col);
                                   newCol.options.display = !columnsToHide.includes(index);
                                   return newCol;
                                 });

                                 setColumns(newCols);
                             }
                       }
                   }
                   else {
                     if (localStorage.getItem('customer_closed_jobs_columns_hide') !== undefined && localStorage.getItem('customer_closed_jobs_columns_hide') !== null &&
                         JSON.parse(localStorage.getItem('customer_closed_jobs_columns_hide')) !== undefined && JSON.parse(localStorage.getItem('customer_closed_jobs_columns_hide')) !== null) {
                           // hide them on the current table
                           var columnsToHide = JSON.parse(localStorage.getItem('customer_closed_jobs_columns_hide'));
                           for (let i = 0; i < columnsToHide.length; i++) {
                               if (tableState.columns.length > i && tableState.columns[i] !== undefined && tableState.columns[i] !== null) {
                                   tableState.columns[i].display = false;
                               }
                           }

                           if (columnsToHide !== undefined && columnsToHide !== null && columnsToHide.length > 0) {
                             var newCols = columnsForCustomer.map((col, index) => {
                               let newCol = Object.assign({}, col);
                               newCol.options.display = !columnsToHide.includes(index);
                               return newCol;
                             });


                             setColumnsForCustomer(newCols);

                           }
                     }
                   }

               },
               customRowRender: (data, dataIndex, rowIndex) => {
                      return  (
                         <TableRow key={data[0]} id={rowIndex}
                                   className={classes.tableRow}
                                   style={{backgroundColor: '#FFFFFF'}}>
                             {(isAll ? columns[0] : columnsForCustomer[0]).options.display && (
                             <TableCell onClick={() => onCellClick(dataIndex, 0)}>
                                 <div>{data[0]}</div>
                             </TableCell>)}
                             {(isAll ? columns[1] : columnsForCustomer[1]).options.display && (
                             <TableCell onClick={() => onCellClick(dataIndex, 1)}>
                                  <div>{data[1]}</div>
                             </TableCell>)}
                             {(isAll ? columns[2] : columnsForCustomer[2]).options.display && (
                             <TableCell onClick={() => onCellClick(dataIndex, 2)}>
                                  <div>{data[2]}</div>
                             </TableCell>)}
                             {(isAll ? columns[3] : columnsForCustomer[3]).options.display && (
                             <TableCell onClick={() => onCellClick(dataIndex, 3)}>
                                  <div>{data[3]}</div>
                             </TableCell>)}
                             {(isAll ? columns[4] : columnsForCustomer[4]).options.display && (
                             <TableCell onClick={() => onCellClick(dataIndex, 4)}>
                                  <div>{data[4]}</div>
                             </TableCell>)}
                             {isAll && columns[5].options.display && (
                             <TableCell onClick={() => onCellClick(dataIndex, 5)}>
                                  <div>{data[5]}</div>
                             </TableCell>)}
                             {isAll && columns[6].options.display && (
                             <TableCell onClick={() => onCellClick(dataIndex, 6)}>
                                 <div>
                                     <IconButton color="primary"
                                           component="span"
                                           onClick={handleClick}>
                                         <MoreVertIcon />
                                     </IconButton>
                                 </div>
                             </TableCell>)}
                             {!isAll && columnsForCustomer[5].options.display && (
                             <TableCell onClick={() => onCellClick(dataIndex, 5)}>
                                 <div>
                                     <IconButton color="primary"
                                           component="span"
                                           onClick={handleClick}>
                                         <MoreVertIcon />
                                     </IconButton>
                                 </div>
                             </TableCell>)}
                         </TableRow>
                       );
               },
               onViewColumnsChange: (changedColumn, action) => {
                 var newCols = (isAll ? columns : columnsForCustomer).map(col => {
                   let newCol = Object.assign({}, col);
                   if (changedColumn === newCol.name) {
                     if (action === "add") {
                       newCol.options.display = true;
                     } else {
                       newCol.options.display = false;
                     }
                   }
                   return newCol;
                 });


                 if (isAll) {
                     setColumns(newCols);
                 }
                 else {
                     setColumnsForCustomer(newCols);
                 }
                 localStorage.setItem(isAll ? 'closed_jobs_columns_hide' : 'customer_closed_jobs_columns_hide',JSON.stringify(newCols.map((c,i) => c.options && c.options !== null && c.options.display !== undefined && c.options.display !== null && !c.options.display ? i : -1).filter(o => o >= 0)));
               }
            }}
          />
        </MuiThemeProvider>
      </Grid>
      </Grid>
      {<div>
        <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}

          >
          <StyledMenuItem onClick={openInNewTab}>
            <ListItemIcon>
              <OpenInNewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Open in New Tab" />
          </StyledMenuItem>
          {/* Group 1: Job Management */}
          <StyledMenuItem disabled className={classes.menuSubtitle}>
              <hr className={classes.submenuLine}/>
              <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Job Management</Typography>
              <hr className={classes.submenuLine}/>
          </StyledMenuItem>
          <StyledMenuItem onClick={copyJob}>
            <ListItemIcon>
              <FileCopyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Copy Job" />
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadHistory}>
            <ListItemIcon>
              <HistoryIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Download History" />
          </StyledMenuItem>
          <StyledMenuItem onClick={openJobReopen}>
            <ListItemIcon>
              <ReplayIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Reopen" />
          </StyledMenuItem>

          {/* Group 2: Invoicing */}
          <StyledMenuItem disabled className={classes.menuSubtitle}>
              <hr className={classes.submenuLine}/>
              <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Invoicing</Typography>
              <hr className={classes.submenuLine}/>
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadInvoicePdf}>
            <ListItemIcon>
              <GetAppIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Invoice PDF" />
          </StyledMenuItem>
          <StyledMenuItem onClick={openInvoiceSummary}>
            <ListItemIcon>
              <ReceiptIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Invoicing Summary" />
          </StyledMenuItem>

          {/* Group 3: Report & Certificate*/}
          <StyledMenuItem disabled className={classes.menuSubtitle}>
              <hr className={classes.submenuLine}/>
              <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Report &amp; Certificate</Typography>
              <hr className={classes.submenuLine}/>
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadJobIssuesReport}>
            <ListItemIcon>
              <GetAppIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Download Above and Beyond Report" />
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadFailedReport}>
            <ListItemIcon>
              <GetAppIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Download Failed Report" />
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadJSA}>
            <ListItemIcon>
              <HistoryIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Download JSA" />
          </StyledMenuItem>
          <StyledMenuItem onClick={openEmail}>
            <ListItemIcon>
              <SendIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Email Report" />
          </StyledMenuItem>
          <StyledMenuItem onClick={generateCertificate}>
              <ListItemIcon>
              <CardMembershipIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Generate Certificate" />
          </StyledMenuItem>

          {/* Group 4: Assets */}
          <StyledMenuItem disabled className={classes.menuSubtitle}>
              <hr className={classes.submenuLine}/>
              <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Assets</Typography>
              <hr className={classes.submenuLine}/>
          </StyledMenuItem>
          <StyledMenuItem onClick={downloadCustomerAssetsCSV}>
            <ListItemIcon>
              <ListAltIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Customer Assets CSV" />
          </StyledMenuItem>
          <StyledMenuItem onClick={openViewAssets}>
            <ListItemIcon>
              <PageviewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="View Assets" />
          </StyledMenuItem>

          {/* Group 5: Communication */}
          <StyledMenuItem disabled className={classes.menuSubtitle}>
              <hr className={classes.submenuLine}/>
              <Typography variant="subtitle2" classeName={classes.menuSubtitleStyle}>Communication</Typography>
              <hr className={classes.submenuLine}/>
          </StyledMenuItem>
          <StyledMenuItem onClick={openTeamChat}>
            <ListItemIcon>
              <ChatIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Open Chat" />
          </StyledMenuItem>
          </StyledMenu>
          </div>

      }


      <JobReportEmail ref={jobReportEmailsRef}
                      email={email}
                      closeMenu={handleClose}/>
      <JobReopen ref={jobReopenRef}
                    closeMenu={handleClose}
                    onReopenSuccess={refreshData}/>
      <CustomerDownloadCSVConfirmation ref={customerDownloadCSVConfirmationRef}
                        closeMenu={handleClose}/>
    </>
  );
});

export default ClosedJobs;
